export const PORTAL_DESCRIPTION_MAX_LENGTH = 300;

export const PORTAL_MAX_ASSETS = 1000;
